import { Select, Input, Modal, Toggle, TextArea } from '@phpcreation/frontend-components-react';
import useTranslation from '@/hooks/shared/translation/useTranslation';
import useModalsStore from '@/lib/global-stores/shared/modals/useModalsStore';
import { submitDataModifier } from '@/lib/helpers/methods';
import { useCreate, get_all_resource } from '@/lib/services/api-config/crud';
import { FormInput, FormInputItem } from '@/utils/types/common';
import React, { FC, useState } from 'react';
import parse from 'html-react-parser';

type Props = {
  resource: string;
  formInputs: FormInputItem[];
};

const ModalAdd: FC<Props> = ({ resource, formInputs }) => {
  const {
    isLoading: isLoadingCreateResource,
    isError: isErrorCreateResource,
    isSuccess: isSuccessCreateResource,
    data: DataCreateResource,
    mutate: create_resource,
  } = useCreate(resource);

  const { modalAdd, setModalAdd } = useModalsStore();

  const [FormData, setFormData] = useState<any>({});
  const [check, setCheck] = useState(false);

  //translate
  const { t } = useTranslation();

  return (
    <Modal
      title={t('Add ') + t(resource.toString().slice(0, resource.length - 1))}
      isOpen={modalAdd.isOpen}
      handleClose={() => {setModalAdd(false),setFormData({})}}
      isButtonOkLoading={isLoadingCreateResource}
      hanldleOK={() => {
        console.log("form data");
        console.log(FormData);

        let adjusted_formData = submitDataModifier(FormData, formInputs);

        console.log("adjusted form data");
        console.log(adjusted_formData);

        //@ts-ignore
        create_resource(adjusted_formData);
        setFormData({})
      }}
      handleCancel={() => {setModalAdd(false),setFormData({})}}
    >
      <div className="flex flex-col items-start space-y-1">
        {formInputs.map((field: FormInputItem, index: any) => {
          if (field.type == 'input')
          return (
            <div
              key={index}
              className="flex flex-col items-start -space-y-2 text-sm"
            >
              <label>{t(field.label)}</label>

              <Input
                // size="large"
                onChange={e =>
                  setFormData({
                    ...FormData,
                    [field.name]: e.target.value,
                  })
                }
                value={FormData[field.name] ?? ''}
                placeholder={`${t(field.placeholder ?? '')}`}
              />
            </div>
          );
          if (field.type == 'text')
            return (
              <div
                key={index}
                className="flex flex-col items-start -space-y-2 text-sm"
              >
                <label>{t(field.label)}</label>
                <TextArea
                  // size="large"
                  onChange={e => setFormData({
                    ...FormData,
                    [field.name]: e.target.value,
                  })}
                  value={FormData[field.name] ?? ''}
                  placeholder={`${t(field.placeholder ?? '')}`} size={'small'}
                />
              </div>
            );
            if (field.type == 'email')
          return (
            <div
              key={index}
              className="flex flex-col items-start -space-y-2 text-sm"
            >
              <label>{t(field.label)}</label>

              <Input
              type='email'
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" 
              required
                // size="large"
                onChange={e =>
                  setFormData({
                    ...FormData,
                    [field.name]: e.target.value,
                  })
                }
                value={FormData[field.name] ?? ''}
                placeholder={`${t(field.placeholder ?? '')}`}
              />
            </div>
          );
          if (field.type == 'phone')
          return (
            <div
              key={index}
              className="flex flex-col items-start -space-y-2 text-sm"
            >
              <label>{t(field.label)}</label>

              <Input
              type='phone'
              pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$" 
              required
                // size="large"
                onChange={e =>
                  setFormData({
                    ...FormData,
                    [field.name]: e.target.value,
                  })
                }
                value={FormData[field.name] ?? ''}
                placeholder={`${t(field.placeholder ?? '')}`}
              />
            </div>
          );
          if (field.type == 'number')
          return (
            <div
              key={index}
              className="flex flex-col items-start -space-y-2 text-sm"
            >
              <label>{t(field.label)}</label>

              <Input
              type='number'
                // size="large"
                onChange={e =>
                  setFormData({
                    ...FormData,
                    [field.name]: parseInt(e.target.value),
                  })
                }
                value={FormData[field.name] ?? ''}
                placeholder={`${t(field.placeholder ?? '')}`}
              />
            </div>
          );
             // CASE Date
            else if (field.type == 'date')
             return (
              <div
                key={index}
                className="flex flex-col items-start -space-y-2 text-sm"
              >
                <label>{t(field.label)}</label>
                
                <Input
                  type='date'
                  // size="large"
                  onChange={e =>
                    setFormData({
                      ...FormData,
                      [field.name]: e.target.value,
                    })
                  }
                  value={FormData[field.name] ?? ''}
                  placeholder={`${t(field.placeholder ?? '')}`}
                />
              </div>
            );
            else if (field.type == 'select')
                return (
                  <div key={index}
                    className="flex flex-col items-start -space-y-0 text-sm"
                  >
                    <label>
                      {t(field.name)}
                    </label>
                    
                    <Select
                      placeholder={t(field.placeholder ? field.placeholder : '')}
                      options={field.optionsArrayFinite}
                      onChange={(newIds: any) => {
                        console.log({ newIds });
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      }}
                      // label={ FormData[field.name]}
                      value={ FormData[field.name]}
                    />
                  </div>
                );
                else if (field.type == 'select_multi' && field.isMulti == true)
                return (
                  <div key={index}
                    className="flex flex-col items-start -space-y-0 text-sm"
                  >
                    <label>
                      {t(field.name)}
                    </label>
                    
                    <Select
                    isMulti={true}
                      placeholder={t(field.placeholder ? field.placeholder : '')}
                      options={field.optionsArrayFinite}
                      defaultOptions
                      cacheOptions={true}
                      onChange={(newIds: any) => {
                        console.log('ttttt',{ newIds });
                        setFormData({
                          ...FormData,
                          [field.name]: newIds,
                        });
                      }}
                      // label={ FormData[field.name]}
                      value={ FormData[field.name]}
                    />
                  </div>
                );
                // CASE Finite + Boolean
                else if (field.type == 'checkbox')
                return (
                  <div
                    className="flex flex-col items-start -space-y-0 text-sm"
                  >
                    <label>
                      {t(field.name)}
                    </label>
                    <Toggle
                    style={{backgroundColor: check == true ? 'blue' : 'red'}}
                    checkedChildren="True" 
                    unCheckedChildren="False"
                    onChange={(newIds: any) => {
                      console.log(FormData[field.name]);
                      setFormData({
                        ...FormData,
                        [field.name]: newIds,
                      });
                      setCheck(newIds)
                    }}
                    key={FormData[field.name]}
                    checked={FormData[field.name]}
                    />
                  </div>
                );
                else if (field.type == 'select_async')
            return (
              <div key={index} className="flex flex-col items-start -space-y-0 text-sm">
                <label>{t(field.label)}</label>

                <Select
                  variant="async"
                  placeholder={field.placeholder}
                  defaultOptions
                  cacheOptions={true}
                  loadOptions={(input, callback) => {
                    get_all_resource(
                      `${field.targetResourceAsync}`,
                      { id: input },
                      false
                    )
                      .then(res =>
                        res.map((i: any) => {
                          return { 
                            label: field.resourceAsyncLabelParam ? parse(i[field.resourceAsyncLabelParam]) : i.id,
                            value: i.id 
                          };
                        })
                      )
                      .then(data => callback(data));
                  }}
                  onChange={(newIds: any) => {
                    console.log({ newIds });
                    setFormData({
                      ...FormData,
                      [field.name]: newIds,
                    });
                  }}
                  value={FormData[field.name]}
                />
              </div>
            );
        })}
      </div>
    </Modal>
  );
};

export default ModalAdd;
